import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpeedometer = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 24,
	viewBox: "0 0 26 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9306 6C3.63584 6 1.13873 14.3237 1 18.0694H25C24.889 9.19075 17.0925 6 12.9306 6Z",
			fill: "#DBE4E8",
			stroke: "#293235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.75 6V8",
			stroke: "#293235",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 9L6.5 10",
			stroke: "#293235",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 10L20.052 8.78035",
			stroke: "#293235",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5954 17.9306C14.5954 17.0112 13.85 16.2659 12.9306 16.2659C12.0112 16.2659 11.2659 17.0112 11.2659 17.9306",
			stroke: "#293235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 10.5L13.0618 16.2205",
			stroke: "#293235",
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSpeedometer);
export { ForwardRef as ReactComponent };
